import { VideoPlayerFactory } from "@outschool/ui-legacy-component-library";

const HlsVideo = () => import(/* webpackChunkName: "Video" */ "hls.js");
const VideoPlayer = VideoPlayerFactory(HlsVideo);
export default VideoPlayer;
